<template>
  <v-navigation-drawer
    id="drawer"
    value="true"
    stateless
  >
    <h1
      v-if="!$vuetify.breakpoint.xs"
      class="title centering"
    >
      Conversations
    </h1>
    <v-list>
      <v-list-item
        v-for="conversation in conversations"
        :key="conversation.pk"
        class="item"
        @click="messageRoom(conversation)"
      >
        <v-list-item-content>
          <h1
            v-if="$vuetify.breakpoint.xs"
            class="first-letter"
          >
            {{ conversation.stakeholder.get_full_name.charAt(0) }}
          </h1>
          <v-list-item-title v-else>
            <v-icon

              color="#263238"
            >
              message
            </v-icon>&nbsp;

            {{ conversation.stakeholder.get_full_name }} &emsp;
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapActions } from "vuex";
import jwt from "jwt-simple";

export default {
  name: "CoversationsList",
  computed: {
    ...mapState("conversations", ["conversations"])
  },
  created() {
    this.fetchConversationsWithObjects();
  },
  methods: {
    ...mapActions("conversations", [
      "fetchConversationsWithObjects",
      "toMessageRoom"
    ]),
    messageRoom(conversation) {
      let encodedConversation = jwt.encode(
        conversation,
        process.env.VUE_APP_JWT_SECRET_KEY,
        "HS256"
      );
      this.$router.push({
        name: "messageroom",
        path: "conversation",
        params: {
          stakeholder: conversation.stakeholder.get_full_name,
          project: conversation.project.name,
          topic: conversation.topic
        },
        query: {
          conversation: encodedConversation,
          sender: localStorage.getItem("TOKEN_STORAGE_KEY")
        }
      });
    }
  }
};
</script>

<style scoped>
.centering {
  align-items: center;
  text-align: center !important;
  font-size: 32px !important;
  padding-top: 1%;
}
div[role="listitem"] {
  border: 2px solid #ccc !important;
  margin-bottom: 0.5%;
}
a:hover {
  text-decoration: none;
}
#drawer {
  padding: 0.5em !important;
  width: 20% !important;
}
.item {
  padding-left: 22.5%;
}
@media (min-width: 320px) and (max-width: 1023px) {
  #drawer >>> a {
    padding: 0;
    margin: 0;
  }
}
</style>
